<app-breadcrumb [title]="'Gestión de Rutas'" [items]="['Extractos']" [active_item]="'Gestión de Rutas'"></app-breadcrumb>
<div class="container-fluid">

    <div class="card">
      <div class="card-header bg-primary">
        <h5 class="text-uppercase text-white">
          <strong>Listado de Rutas</strong>
        </h5>
      </div>

      <div class="card-body custom-datatable noscroll my">
        <div class="row mb-12">
      <div class="col-3 ms-auto"> 
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar....."
            [(ngModel)]="searchText"
            (input)="filterData()"
          />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>
        <div class="custom-datatable table-responsive my-4">
          <table class="table table-hover table-bordered" id="tblRutas">
            <thead class="bg-primary">
              <tr>
                <th class="text-center" style="cursor: pointer"><strong>ID</strong></th>
                <th class="text-center" style="cursor: pointer"><strong>NOMBRE DE LA RUTA</strong></th>
                <th class="text-center" style="cursor: pointer"><strong>RUTA</strong></th>
                <th class="text-center" style="cursor: pointer"><strong>ORIGEN</strong></th>
                <th class="text-center" style="cursor: pointer"><strong>DESTINO</strong></th>
                <th class="text-center" style="cursor: pointer"><strong>OPCIONES</strong></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let ruta of rutas of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                <td class="text-center">{{ ruta.id }}</td>
                <td class="text-center">{{ ruta.nombre }}</td>
                <td class="text-center">{{ ruta.ruta }}</td>
                <td class="text-center">{{ ruta.municipioOrigen?.MUNICIPIO }}</td>
                <td class="text-center">{{ ruta.municipioDestino?.MUNICIPIO }}</td>

                <!-- Buscar tarjeta correspondiente -->
                <td>
                  <div class="action text-center">
                    <ul class="list-inline">
                      <li class="edit">
                        <a href="javascript:void(0)"><i class="icon-pencil-alt" (click)="openModal(myModal3, ruta.id)" ngbTooltip="Editar"></i></a>
                      </li>
                      <li class="delete">
                        <a href="javascript:void(0)"><i class="icon-trash" (click)="actualizarEstadoRutaAInactivo(ruta.id)" ngbTooltip="Inactivar"></i></a>
                      </li>
                      <li>

                      </li>
                    </ul>
                  </div>                      
                </td>
                
                
                
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-4">
          <!-- Selector de registros por página alineado a la izquierda -->
          <div class="d-flex align-items-center">
            <label for="pageSize1" class="me-2">Mostrar:</label>
            <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
              <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>
        
          <div class="mx-auto text-center">
            <span class="badge bg-primary ms-1"><b><span>Total registros: </span>{{ rutas.length || 0 }}</b></span>
          </div>
        
          <!-- Paginador alineado a la derecha -->
          <div class="text-end paginador-personalizado">
            <pagination-controls 
              (pageChange)="page1 = $event" 
              [maxSize]="5"
              
              [directionLinks]="true"
              [autoHide]="true"
              previousLabel="Anterior" 
              nextLabel="Siguiente">
            </pagination-controls>
          </div>
        </div>
        <div class="card-body">
          <div class="btn-showcase text-center">
            <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
              (click)="
                exportarExcel(
                  'tblRutas',
                  'Listado_Rutas'
                )
              ">
              <i class="icofont icofont-file-excel"></i> EXCEL
            </button>

            <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
              (click)="
                exportToPDF(
                  'tblRutas',
                  'Listado_Rutas',
                  'Listado de Rutas'
                )
              ">
              <i class="icofont icofont-file-pdf"></i> PDF
            </button>

            <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Crear"
                  (click)="openModal(myModal3)">
                  <i class="icofont icofont-plus"></i> Crear
            </button>
          </div>
        </div>
      </div>
    </div>

</div>

<ng-template #myModal3 let-modal>
    <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR RUTA - ID: ' + rutaForm.get('id')?.value : 'CREACIÓN DE RUTA' }}
      </h5>
    </div>
  <div class="card-body">
    <form [formGroup]="rutaForm" >
      <div class="row g-3">
        <div class="col-md-3 mb-3">
          <label class="form-label"><strong>Origen *:</strong></label>
          <ng-select 
            #inputOrigen
            [items]="municipios"
            bindLabel="MUNICIPIO"
            bindValue="IDMUN"
            placeholder="Seleccione el origen"
            [(ngModel)]="origenSeleccionado"
            (change)="actualizarNombreRuta()"
            formControlName="origen">
          </ng-select>
        </div>

        <div class="col-md-3 mb-3">
          <label class="form-label"><strong>Destino *:</strong></label>
          <ng-select 
            [items]="municipios"
            bindLabel="MUNICIPIO"
            bindValue="IDMUN"
            placeholder="Seleccione el destino"
            [(ngModel)]="destinoSeleccionado"
            (change)="actualizarNombreRuta()"
            formControlName="destino">
          </ng-select>
        </div>

        <div class="col-md-3 mb-3">
          <label class="form-label"><strong>Nombre de la ruta *:</strong></label>
          <input
            class="form-control"
            type="text"
            placeholder="Ingrese el nombre de la ruta"
            [value]="nombreRuta"
            formControlName="nombre" />
        </div>

        <div class="col-md-3 mb-3">
          <label class="form-label"><strong>Descripción *:</strong></label>
          <input
            class="form-control"
            type="text"
            placeholder="Ingrese descripción"
            formControlName="ruta" />
        </div>
      </div>


      <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarRuta()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
    </form>
  </div>
  </div>
</ng-template>